import {
    Component, OnInit, Input, OnDestroy,
    AfterViewInit, ChangeDetectionStrategy,
    ChangeDetectorRef, ViewChild, SimpleChanges, OnChanges
} from '@angular/core';
// Animations
import { slideInDownAnimation } from '../../../app/app.animation';

import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import * as fromExternalManagement from '../../../screens/external-users-management/state/external-users-management.selectors';
import * as ExternalManagementActions from '../../../screens/external-users-management/state/external-users-management.actions';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import { FormBuilder } from '@angular/forms';
import { AngularMaterialService, ErrorParseService, IExternalData, IOrgInfoExt, LGEDataService } from '../..';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, of } from 'rxjs';
@Component({
    selector: 'ext-management-table-component',
    templateUrl: 'ext-management-table.component.html',
    styleUrls: ['ext-management-table.component.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExtManagementTableComponent implements OnInit, OnChanges {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    @Input() data: any[];
    @Input() tableType: string;
    private datePipe = new DatePipe('en-US');
    public dataSource: MatTableDataSource<any>;
    selection = new SelectionModel<any>(true, []);

    private selectedRequests = [];
    private localData: any[];
    private isShowVAlidate = false;
    private isAllChecked: boolean = false;
    private isIndeterminate: boolean = false;
    private isDeleting = false;
    private type = '';
    public displayedColumns = [
        'OrganizationName',
        'EIN',
        'taxExemptStatus',
        'FirstName',
        'LastName',
        'Phone',
        'Email',
        'Status',
        'EINStatus',
        'Approve',
        'Reject'
    ];

    constructor(
        private store: Store<fromExternalManagement.State>,
        private ref: ChangeDetectorRef,
        private fb: FormBuilder,
        private ams: AngularMaterialService,
        private errorParse: ErrorParseService,
        private _dataService: LGEDataService,
        private route: ActivatedRoute,
        private router: Router
    ) {
    }
    ngOnInit() {
        setTimeout(() => {
            this.localData = this.data;
            this.buildDataSource(this.localData);
        });
    }


    private buildDataSource(data: any) {
        const filter = this.dataSource !== undefined ? this.dataSource.filter : '';
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.sortingDataAccessor = (item: IExternalData, property) => {
            switch (property) {
                case 'OrganizationName':
                    return item.orgInfoExt.name?.toLocaleLowerCase();
                case 'FirstName':
                    return item.externalUser.firstName?.toLocaleLowerCase();
                case 'LastName':
                    return item.externalUser.lastName?.toLocaleLowerCase();
                case 'Email':
                    return item.externalUser.email?.toLocaleLowerCase();
                case 'Status':
                    return item.externalUser.accessStatus === 'pendingEIN' ? 'pending ein verification' : item.externalUser.accessStatus?.toLocaleLowerCase();
                case 'EINStatus':
                    return this.getEinStatus(item.externalUser.isVerified);
                case 'taxExemptStatus':
                    return this.getTaxExemptStatus(item.orgInfoExt.subsection_501);
            }
        }
        this.dataSource.filterPredicate = (data, filter: string) => {
            const accumulator = (currentTerm, key) => {
                switch (key) {
                    case 'orgInfoExt':
                        return currentTerm + data.orgInfoExt.name?.toLocaleLowerCase()
                            + data.orgInfoExt.EIN;
                    case 'externalUser':
                        return currentTerm + data.externalUser.firstName?.toLocaleLowerCase()
                            + data.externalUser.lastName?.toLocaleLowerCase()
                            + data.externalUser.email?.toLocaleLowerCase()
                            + (data.externalUser.accessStatus === 'pendingEIN' ? 'pending ein verification' : data.externalUser.accessStatus?.toLocaleLowerCase())
                            + this.getEinStatus(data.externalUser.isVerified)
                            + this.getTaxExemptStatus(data.orgInfoExt.subsection_501);
                    case 'orgContactInfoExt':
                        return currentTerm + data.orgContactInfoExt.phone;
                    default:
                        return currentTerm + '';
                }
                // return key === 'OrgInfo' ? currentTerm + data.OrgInfo.name : currentTerm + data[key];
            };
            const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
            // Transform the filter by converting it to lowercase and removing whitespace.
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.includes(transformedFilter);
        };
        this.dataSource.filter = filter;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }


    getEinStatus(isVerified: number): string {
        switch (isVerified) {
            case 0:
                return 'Unverified';
            case 1:
                return 'Verified';
            case 2:
                return 'Expired';
            default:
                return 'Unverified';
        }
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes['data']) {
            setTimeout(() => {
                this.data = changes['data'].currentValue;
                this.localData = this.data;
                this.buildDataSource(this.localData);
            })
        }
    }
    getTaxExemptStatus(value) {
        if (value === '')
            return 'Other';
        else if (isNaN(value) || +value === 0) {
            return value;
        } else {
            return `501(c)(${+value})`;
        }
    }

    showAccessRequestDetails(ext: IExternalData, isApproving: boolean = true) {
        this.ams.showAccessRequestDetails('Access Request Details', ext, isApproving);
    }

    approveAccess(user: IExternalData) {
        // event.stopPropagation();
        if (user.externalUser.isVerified === 1) {
            this.approvingAccess(user);
        } else if (user.externalUser.isVerified === 2) {
            this.ams.showLoader('Validating expired EIN...');
            this.ref.markForCheck();
            this._dataService.CharityCheck(user.orgInfoExt.EIN).subscribe({
                next: (result) => {
                    if (result !== 'invalid' && result !== 'Expired') {
                        let approvedUser = JSON.parse(JSON.stringify(user));
                        approvedUser.orgInfoExt.name = result.organization_name.toUpperCase()
                        approvedUser.orgInfoExt.subsection_501 = result.subsection_501;
                        this.approvingAccess(user);
                        console.log(user);
                    } else {
                        throw new Error(result);
                    }
                }, error: error => {
                    this.ams.closeDialog();
                    if (error.message === 'invalid') {
                        this.ams.showAlert('Unverified EIN', 'The EIN was not found from Guidestar or Exception List. Please double check organization information before further decision.')
                        this.ref.markForCheck();
                        this.ams.alert.afterClosed().subscribe(result => {
                            this.showAccessRequestDetails(user, true);
                        })
                    } else {
                        this.ams.showAlert('Expired Exception EIN', 'The EIN used on this profile is an Expired Exception EIN. Please review the Exception EIN before further action.');
                        this.ref.markForCheck();
                        this.ams.alert.afterClosed().subscribe(result => {
                            this._dataService.setEINExceptionFilter(user.orgInfoExt.EIN);
                            this.router.navigate(['/admin/ein-configuration']);
                        })
                    }
                }
            })

        } else {
            this._dataService.CharityCheck(user.orgInfoExt.EIN).subscribe({
                next: (result) => {
                    if (result !== 'invalid' && result !== 'Expired') {
                        this.ams.closeDialog();
                        this.ref.markForCheck();
                        let approvedUser = JSON.parse(JSON.stringify(user));
                        approvedUser.orgInfoExt.name = result.organization_name.toUpperCase()
                        approvedUser.orgInfoExt.subsection_501 = result.subsection_501;
                        this.approvingAccess(user);
                        console.log(approvedUser);
                    } else {
                        throw new Error(result);
                    }
                }, error: error => {
                    this.ams.closeDialog();
                    if (error.message === 'invalid') {
                        this.ams.showAlert('Unverified EIN', 'The EIN was not found from Guidestar or Exception List. Please double check organization information before further decision.')
                        this.ref.markForCheck();
                        this.ams.alert.afterClosed().subscribe(result => {
                            this.showAccessRequestDetails(user, true);
                        })
                    } else {
                        this.ams.showAlert('Expired Exception EIN', 'The EIN used on this profile is an Expired Exception EIN. Please review the Exception EIN before further action.');
                        this.ref.markForCheck();
                        this.ams.alert.afterClosed().subscribe(result => {
                            this._dataService.setEINExceptionFilter(user.orgInfoExt.EIN);
                            this.router.navigate(['/admin/ein-configuration']);
                        })
                    }
                }
            })
        }
    }

    private approvingAccess(user: IExternalData) {
        let approvedUser: IExternalData = {
            orgInfoExt: user.orgInfoExt,
            orgContactInfoExt: user.orgContactInfoExt,
            externalUser: Object.assign({}, user.externalUser, {
                accessStatus: "approved"
            })
        }
        // this.store.dispatch(new ExternalManagementActions.ApproveUser(approvedUser));
        this.ams.showLoader('Approving...');
        this._dataService.extProfileApproveReject(approvedUser).subscribe({
            next: response => {
                this.ams.closeDialog();
                if (response === 'approved') {
                    this.ams.showAlert('Success', 'Successfully approved!');
                    let leaving = setTimeout(() => {
                        this.ams.closeDialog();
                        this.store.dispatch(new ExternalManagementActions.LoadExternalManagementState);
                    }, 5000);
                    this.ams.alert.afterClosed().subscribe(() => {
                        this.ams.closeDialog();
                        this.store.dispatch(new ExternalManagementActions.LoadExternalManagementState);
                        clearTimeout(leaving);
                    })
                } else if (response === 'failed') {
                    this.ams.showAlert('Error', 'Could not approve the profile, please try again later!');
                }
            },
            error: error => { of(new ExternalManagementActions.ApproveUserFailed(error)) }
        })
    }

    rejectAccess(user: IExternalData) {
        event.stopPropagation()
        console.log('rejected');
        let rejectedUser: IExternalData = {
            orgInfoExt: user.orgInfoExt,
            orgContactInfoExt: user.orgContactInfoExt,
            externalUser: Object.assign({}, user.externalUser, {
                accessStatus: "rejected"
            })
        };
        this.store.dispatch(new ExternalManagementActions.RejectUser(rejectedUser));
    }

    clearFilter() {
        this.dataSource.paginator.pageIndex = 0;
        this.onChangeAccessStatusFilter('');
    }

    approvedFilter() {
        this.dataSource.paginator.pageIndex = 0;
        this.onChangeAccessStatusFilter('approved');
    }

    rejectedFilter() {
        this.dataSource.paginator.pageIndex = 0;
        this.onChangeAccessStatusFilter('rejected');
    }

    pendingFilter() {
        this.dataSource.paginator.pageIndex = 0;
        this.onChangeAccessStatusFilter('pending');
    }

    pendingEINFilter() {
        this.onChangeAccessStatusFilter('pendingEIN');
    }

    onChangeAccessStatusFilter(value) {
        this.localData = JSON.parse(JSON.stringify(this.data));
        if (value !== '') {
            this.localData = this.localData.filter(item => item.externalUser.accessStatus === value);
        }
        this.buildDataSource(this.localData);
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }
}